import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QuestionnaireProcessStep } from 'src/app/common/enums';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { WorkerProfile } from 'src/app/models/WorkerProfile';

@Component({
  selector: 'app-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss'],
  standalone: false
})
export class AdditionalInfoComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);

  profile: WorkerProfile;
  questionnaireProcessStep = QuestionnaireProcessStep;

  constructor() { }

  get authServerUserId(): string {
    return this.profile?.AuthServerUserId;
  }

  get isSelfProfile(): boolean {
    return this.authServerUserId === this.authService.authServerUserId;
  }

  get emergencyContactOnProfile(): boolean {
    return (this.profile?.EmergencyContactPhone !== null ||
      this.profile?.EmergencyContactAddress !== null ||
      this.profile?.EmergencyContactFirstName !== null ||
      this.profile?.EmergencyContactLastName !== null);
  }

  ngOnInit(): void {
    this.route.parent.data.subscribe((data) => (this.profile = data['workerProfile']));
  }
}
